import PropTypes from 'prop-types';
import { get } from 'lodash';
import { NgpLabelValue } from '../../../../../form/NgpLabelValue';
import TestSubFormSection from '../TestFormSection/TestSubFormSection';
import { useNoPaddingLeftStyles } from '../../../../../form/FormStyles';

/**
 * Shared VoIP agent configuration display for Caller or Callee.
 * Shows call manager, phone number, and extension from voipConfiguration.
 *
 * @param {Object} props
 * @param {Object} props.agent - Agent object with voipConfiguration
 * @param {React.ReactNode} props.title - Section title (Trans-wrapped)
 */
export function AgentDetailsSection({ agent, title }) {
    const noPaddingLeftStyles = useNoPaddingLeftStyles();

    return (
        <TestSubFormSection
            title={title}
            fieldsClassName={noPaddingLeftStyles.ngpFormFields}
            useTestSmallSubFormSection
        >
            {get(agent, 'voipConfiguration.primaryCallManager.name') && (
                <NgpLabelValue
                    dataLabel="Call Manager"
                    dataValue={get(agent, 'voipConfiguration.primaryCallManager.name')}
                    showIfEmpty
                />
            )}
            {get(agent, 'voipConfiguration.phoneNumber') && (
                <NgpLabelValue
                    dataLabel="Phone Number"
                    dataValue={get(agent, 'voipConfiguration.phoneNumber')}
                    showIfEmpty
                />
            )}
            {get(agent, 'voipConfiguration.extension') && (
                <NgpLabelValue
                    dataLabel="Extension"
                    dataValue={get(agent, 'voipConfiguration.extension')}
                    showIfEmpty
                />
            )}
        </TestSubFormSection>
    );
}

AgentDetailsSection.propTypes = {
    agent: PropTypes.object.isRequired,
    title: PropTypes.node.isRequired,
};
